import { getEstimationTimeForAllProducts, getProductSelectionTypesOptions } from '~/ocab-services/measure/utils';
import { RoomOrSpaceTooltip } from '~/ocab-services/measure/components/room-or-space-tooltip';
import { Select } from 'jl-design-system/components/select/Select';
import { addressHelpers } from '~/ocab-services/measure/routes/helpers';
import { msToPartDayTime } from '~/routes/utils';
import { AppointmentDurationEstimation } from '~/ocab-services/measure/components';

export const config = {
  v1: {
    PostcodeSearchForm: {
      errorMessageForUnsupportedPostcode: {
        type: 'NO_ADDRESSES_FOUND_ERROR',
        description: (
          <p>
            {`We do not offer this service in your area, please contact us on `}
            <a href="tel:0345 608 0850">0345 608 0850</a>
            {` or email `}
            <a href="mailto: flooring.scheduling@johnlewis.co.uk">flooring.scheduling@johnlewis.co.uk</a>
            {` to discuss other options`}
          </p>
        ),
      },
    },
    ProductsForm: {
      productTypeLabel: 'What type of flooring are you interested in?',
      productTypeLabelForDefaultOption: 'Select type of flooring',
      quantityLabel: 'How many rooms is this for?',
      productInformationLabel: 'Tell us more about the room(s)',
      productInformationInstruction: 'To help make the most of your time with our estimator, please tell us about any products you have in mind, rough room sizes or special requirements (such as pets, allergies, easy to clean, etc).',
      productInformationValidationMessage: 'Please give us details about your room(s)',
      getProductSelectionTypesConfig: products => ({
        component: Select,
        label: 'Room or space?',
        labelHelperElement: (<RoomOrSpaceTooltip usedFor={'floor'}/>),
        required: true,
        validationMessageKeys: {
          required: 'Please select room or space',
        },
        className: 'fieldMedium',
        options: getProductSelectionTypesOptions(products, 'Select room or space'),
      }),
    },
    BookingReview: {
      displayPropertyAddress: true,
      hideShopDetails: true,
      hidePriceDetails: true,
      hidePartnerDetails: true,
      hideAddToCalendarButton: false,
      hideManageAppointmentsButton: true,
      formatBookingAddressFunc: addressHelpers.formatBookingPropertyAddress,
      BookingDate: {
        formatTimeSlot: startTime => msToPartDayTime(startTime),
        appointmentDurationEstimationComponent: AppointmentDurationEstimation,
        buildAppointmentEstimationDurationDescription: duration => `Your appointment will last around ${duration}`,
      },
      icsEvent: {
        getTitle: ({ appointmentTypeTitle }) => `John Lewis ${appointmentTypeTitle} measuring service`,
        getAppointmentInfoSection: appointmentTypeName => `John Lewis & Partners ${appointmentTypeName} at home measuring service`,
        getCustomAdditionalInfoSection: ({ products = [] } = {}) => (
          `\\nApproximate duration will be: ${getEstimationTimeForAllProducts(products)}`
          + '\\n\\nFor any questions regarding your appointment, or to amend or cancel please contact us on 0345 608 0850 or email flooring.scheduling@johnlewis.co.uk'
        ),
      },
    },
  },
};
